export default __webpack_public_path__ + "static/media/kratzy76au.8a6fc19e.mp4";